import type { SVGProps } from "react";

export function SidebarCollapse(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 2.25C18.4142 2.25 18.75 2.58579 18.75 3V17C18.75 17.4142 18.4142 17.75 18 17.75C17.5858 17.75 17.25 17.4142 17.25 17V3C17.25 2.58579 17.5858 2.25 18 2.25ZM7.96967 2.96967C8.26256 2.67678 8.73744 2.67678 9.03033 2.96967L15.5303 9.46967C15.671 9.61032 15.75 9.80109 15.75 10C15.75 10.1989 15.671 10.3897 15.5303 10.5303L9.03033 17.0303C8.73744 17.3232 8.26256 17.3232 7.96967 17.0303C7.67678 16.7374 7.67678 16.2626 7.96967 15.9697L13.1893 10.75H2C1.58579 10.75 1.25 10.4142 1.25 10C1.25 9.58579 1.58579 9.25 2 9.25H13.1893L7.96967 4.03033C7.67678 3.73744 7.67678 3.26256 7.96967 2.96967Z"
        fill="currentColor"
      />
    </svg>
  );
}
